import { render } from "./stockadjustment.vue?vue&type=template&id=459e7922&scoped=true"
import script from "./stockadjustment.vue?vue&type=script&lang=js"
export * from "./stockadjustment.vue?vue&type=script&lang=js"

import "./stockadjustment.vue?vue&type=style&index=0&id=459e7922&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459e7922"]])

export default __exports__